import { Input, InputProps } from '@aqarmap/aqarmap-ui';
import { Controller, Control } from 'react-hook-form';
import MaskedInput, { Mask } from 'react-text-mask';

type MaskRefType = (inputElement: HTMLElement) => void;
type MaskProp = {
  onChange: (event: React.ChangeEvent<HTMLElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLElement, Element>) => void;
  defaultValue: string | undefined;
};
type Props = InputProps & {
  control: Control<any>;
  mask: Mask | ((value: string) => Mask);
};

const MaskedInputAny = MaskedInput as any;

export default function MaskedInputController({
  control,
  mask,
  field: { placeholder, name },
  ...restInput
}: Props) {
  return (
    <Controller
      control={control}
      name={name as string}
      render={({
        //eslint-disable-next-line @typescript-eslint/no-unused-vars
        field: { onChange, value, ref, ...restField },
        fieldState: { error },
      }) => (
        <MaskedInputAny
          ref={null}
          mask={mask}
          placeholder={placeholder}
          guide={false}
          value={value}
          onChange={onChange}
          render={(maskRef: MaskRefType, maskProp: MaskProp) => (
            <Input
              ref={maskRef as any}
              field={{
                name,
                placeholder,
                onChange: maskProp.onChange,
              }}
              error={error?.message}
              {...restInput}
              {...maskProp}
            />
          )}
          {...restField}
        />
      )}
    />
  );
}
